import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'
import VueMatchHeights from 'vue-match-heights';
import VueTheMask from 'vue-the-mask'
import Notifications from 'vue-notification'

Vue.use(Notifications);
Vue.use(VueTheMask)
Vue.use(VueMatchHeights);
Vue.use(VueResource);

new Vue({
  el: '#app',
  render: h => h(App)
})
.$root.$on('atualizarTexto', (texto) => {
  const element = document.getElementById('test');
  if (element) {
    element.textContent = texto;
  }
});




// WEBPACK FOOTER //
// ./src/main.js